module.exports = __webpack_public_path__ + "static/media/sudo-map.5ee02432.png";